import {
  applyMiddleware,
  createStore,
  compose,
} from "redux";
import promise from "redux-promise-middleware";
import thunk from "redux-thunk";

import {
  persistStore,
  persistReducer,
  createTransform
} from "redux-persist";

import storage from "./storage";

import { createFilter } from "redux-persist-transform-filter";

import { Signer, Cipher } from "@flixxo/authorizator";

import { rootReducer } from './rootReducer'
import { STATE_VERSION } from "config/constants";

const initialState = {};



const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const authFilter = createFilter("authReducer", [
  "secret",
  "isModerator",
  "seriesCreator",
  "email",
  "isLoggedIn",
  "isRegistered",
  "isConfirmed",
]);

const userFilter = createFilter("userReducer", ["communityFilter"]);

const signerAndCipherTransform = createTransform(
  (inboundState) => inboundState,
  (outboundState, key) => {
    if (key === "authReducer") {
      if (outboundState.secret) {
        return {
          ...outboundState,
          signer: new Signer(outboundState.secret),
          cipher: new Cipher(outboundState.secret),
        };
      } else return outboundState;
    }
    return outboundState;
  }
);

const persistConfig = {
  key: "root",
  version: STATE_VERSION,
  transforms: [
    authFilter,
    userFilter,
    signerAndCipherTransform,
  ],
  whitelist: [
    "authReducer",
    "torrentReducer",
    "onboardingReducer",
    "contentReducer",
    "categorieReducer",
    "content",
  ],
  storage,
  migrate: (state, version) => {
    if (!state || state._persist.version !== version) {
      return Promise.resolve(initialState)
    }
    return Promise.resolve(state)
  }
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export let store = createStore(
  persistedReducer,
  initialState,
  composeEnhancers(applyMiddleware(thunk, promise))
);

export let storeStorybook = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

export let persistor = persistStore(store);
